import Layout from 'components/layout/Layout'
import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations'
import i18nConfig from 'utils/i18nConfig'
import EncyclopediaSubCategory from 'features/encyclopedia/sub-category/EncyclopediaSubCategory'
import { DEFAULT_NAMESPACES } from 'constants/i18n'
import type { SeoProps } from 'components/seo/types'
import { cmsLib } from 'lib'
import { EncyclopediaSubcategoryProps } from 'features/encyclopedia/sub-category/types'
import { mapCmsEncyclopediaArticlesToArticles } from 'utils/cms'

const EncyclopediaSubCategoryPage = (props: EncyclopediaSubcategoryProps) => {
  // Constants
  const { seo, title } = props.subCategory
  const SEO: SeoProps = {
    description: seo?.metaDescription,
    image: seo?.seoImage?.url,
    title: seo?.seoTitle ?? title
  }

  return (
    <Layout seo={SEO}>
      <EncyclopediaSubCategory {...props} />
    </Layout>
  )
}

export const getStaticProps = async ({ params, locale }) => {
  const { subCategory: subCategorySlug } = params

  // Fetch the data
  const [subCategory, encyclopediaArticles] = await Promise.all([
    cmsLib.getEncyclopediaSubcategoryBySlug(subCategorySlug),
    cmsLib.getEncyclopediaArticles()
  ])
  if (!subCategory) {
    return {
      notFound: true,
      revalidate: 5
    }
  }

  // Convert the articles (for filtering & using in the components)
  const articles = mapCmsEncyclopediaArticlesToArticles(encyclopediaArticles)

  // Get articles for subcategory
  const subcategoryArticles = articles.filter((article) => article.subcategory.slug === subCategorySlug)

  return {
    props: {
      articles: subcategoryArticles,
      subCategory,
      ...(await serverSideTranslations(locale, [...DEFAULT_NAMESPACES, 'encyclopedia'], i18nConfig))
    },
    revalidate: 10 // re-generate page when a request comes in, once every 10 seconds
  }
}

export const getStaticPaths = async () => {
  const subCategoryPaths = []

  const subCategories = await cmsLib.getEncyclopediaSubcategories()

  subCategories.forEach((subCat) => {
    const subCatPaths = [
      { locale: 'nl', params: { category: subCat.category.slug, subCategory: subCat.slug } }
      // { params: { subCategory: subCat.slug, category: subCat.category.slug }, locale: 'fr' }
    ]

    subCategoryPaths.push(...subCatPaths)
  })

  return {
    fallback: 'blocking',
    paths: subCategoryPaths // will server-render pages on-demand if the path does not exist
  }
}

export default EncyclopediaSubCategoryPage
